var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVideoPurple = function SvgIconVideoPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.52335H12.0383",
    stroke: "#533366",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51367 4.32522V2.95617C4.51357 2.89891 4.52868 2.84266 4.55746 2.79317C4.58625 2.74367 4.62767 2.70272 4.67748 2.67449C4.72729 2.64627 4.78372 2.63179 4.84097 2.63253C4.89822 2.63328 4.95424 2.64923 5.0033 2.67875L7.96815 4.0483C8.01617 4.07696 8.05592 4.11759 8.08353 4.16621C8.11114 4.21484 8.12565 4.2698 8.12565 4.32572C8.12565 4.38164 8.11114 4.4366 8.08353 4.48523C8.05592 4.53385 8.01617 4.57448 7.96815 4.60314L5.0033 5.97269C4.95421 6.00204 4.89822 6.01786 4.84103 6.01853C4.78384 6.01919 4.7275 6.00469 4.67774 5.9765C4.62797 5.9483 4.58658 5.90742 4.55776 5.85802C4.52894 5.80862 4.51372 5.75246 4.51367 5.69527V4.32522Z",
    stroke: "#533366",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2858 0.5H1.2525C0.5 0.5 0.5 1.2525 0.5 1.2525V8.7775C0.5 9.53 1.2525 9.53 1.2525 9.53H11.2858C12.0383 9.53 12.0383 8.7775 12.0383 8.7775V1.2525C12.0383 0.5 11.2858 0.5 11.2858 0.5Z",
    stroke: "#533366",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconVideoPurple;